import { QUERY_PARAMS_SIGN } from 'consts/paths/queryParams';

export const getFullPath = (path: string, searchParams: string) =>
    `${path}${QUERY_PARAMS_SIGN}${searchParams}`;
